import moment from 'moment';

import getUrl from '@/routes/routes/helpers/getUrl';

import {
  formatDateLong,
  formatPrice,
  formatDateMonthFull,
} from '../../utils/formats';

import organiserResolver from './organiser';
import raceResolver from './race';

const getRaces = (event) => {
  if (typeof event.races.races === 'undefined') {
    return {
      races: [],
    };
  }

  return {
    races: event.races.races.map((race) => ({
      ...raceResolver({
        ...race,
        country: event.place.address.countryShort,
      }),
      canonical: `${WEB_ROOT}${getUrl.eventPage(
        event.place.address.countryShort,
        event.slug,
        event.id,
      )}`,
    })),
  };
};

export const getPermalink = (event) => {
  return getUrl.eventPage(
    event.place.address.countryShort,
    event.slug,
    event.id,
  );
};

/**
 * Event detail resolver.
 * This pure function annotates event detail objects with computed values, e.g. formatted strings.
 */
const resolver = (event) => {
  return (
    event && {
      ...event,
      permalink: getPermalink(event),
      reviewPermalink: getUrl.eventReviewForm({
        eventId: event.id,
      }),
      canonical: `${WEB_ROOT}${getUrl.eventPage(
        event.place.address.countryShort,
        event.slug,
        event.id,
      )}`,
      // Format start date, optional
      ...(event.startDate && {
        startDateFormatted: formatDateLong(event.startDate),
        startMonth: moment(event.startDate)
          .format('MMM')
          .toUpperCase(),
        startMonthFormatted: formatDateMonthFull(event.startDate),
        startMonthNumeric: parseInt(moment(event.startDate).format('M'), 10),
        startDay: moment(event.startDate).format('D'),
        startDayNumeric: parseInt(moment(event.startDate).format('D'), 10),
        daysToGo: moment.utc(event.startDate).diff(moment.utc(), 'days'),
      }),
      // Organiser is optional
      ...(event.organiser && {
        organiser: organiserResolver(event.organiser),
      }),
      // Races are optional
      ...(event.races && {
        races: {
          ...event.races,
          // Format from price, optional (number)
          ...(typeof event.races.pricesFrom !== 'undefined' &&
            event.races.pricesFrom !== null && {
              pricesFromFormatted: formatPrice(
                event.races.currencyLabel,
                event.races.pricesFrom,
              ),
            }),
          // Format to price, optional (number)
          ...(typeof event.races.pricesTo !== 'undefined' &&
            event.races.pricesTo !== null && {
              pricesToFormatted: formatPrice(
                event.races.currencyLabel,
                event.races.pricesTo,
              ),
            }),
          ...getRaces(event),
        },
      }),
      geometry: {
        coordinates: event.location
          ? [event.location.long, event.location.lat]
          : null,
      },
      badges: event.badges ?? null,
      tags: event.tags ?? [],
    }
  );
};

export default resolver;
